import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { datadogRum } from '@datadog/browser-rum';
import { environment } from './environments/environment';

if (environment.datadog?.enabled) {
  datadogRum.init(environment.datadog);
}

bootstrapApplication(App, appConfig).catch((err: unknown) => console.error(err));
